import { Dialog, DialogContent, DialogActions } from "@material-ui/core";
import {
    Button,
    FormWithRedirect,
    ReferenceInput,
    SaveButton,
    useNotify,
    AutocompleteInput,
    useUpdateMany,
    useListContext,
    required
} from "react-admin";
import { useToggler } from "../shared/hooks/useToggler";
import IconCancel from "@material-ui/icons/Cancel";

export const ChangePaymentTerms = () => {
    const { value, setTrue, setFalse } = useToggler();
    const notify = useNotify();

    const [updateMany, { loading }] = useUpdateMany();
    const { selectedIds, refetch } = useListContext();
    const onClick = (values: any) => {
        updateMany("subjects", selectedIds, values, {
            onFailure: () => notify("Errore!", "error"),
            onSuccess: (response: any) => {
                let errors = "";
                for (let k in response.errors) {
                    errors += k + " -> " + response.errors[k] + "\n "
                }
                if (errors !== "") {
                    window.alert(errors);
                }
                else {
                    notify("Missioni aggiornate");
                }
                setFalse();
                refetch();
            },
        });
    };

    return (
        <>
            <Button
                onClick={(e) => {
                    e.stopPropagation();
                    setTrue();
                }}
                label={"Cambia metodo di pagamento"}
            ></Button>
            <Dialog
                open={value}
                onClick={(e) => e.stopPropagation()}
                fullWidth
                maxWidth="sm"
            >
                <FormWithRedirect
                    resource="project-collaborators"
                    save={onClick}
                    render={({ handleSubmitWithRedirect, saving }) => (
                        <>
                            <DialogContent>
                                <ReferenceInput
                                    fullWidth
                                    label="Metodo di pagamento"
                                    source="payment_terms_id"
                                    reference="autocomplete/terms-payment"
                                    validate={[required()]}
                                >
                                    <AutocompleteInput optionText="label" />
                                </ReferenceInput>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    label="ra.action.cancel"
                                    onClick={setFalse}
                                    disabled={loading}
                                >
                                    <IconCancel />
                                </Button>
                                <SaveButton
                                    handleSubmitWithRedirect={handleSubmitWithRedirect}
                                    saving={saving}
                                    disabled={loading}
                                />
                            </DialogActions>
                        </>
                    )}
                />
            </Dialog>
        </>
    );
};
